export default "<p>update-browse works!</p>\n"